import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { ReactComponent as AssignPlanIcon } from "assets/assignPlan.svg";
import ThemeContext from "components/app/Context";
import Button from "components/common/Button";
import Scroller from "components/common/Scroller/InfiniteScroller";
import Typography from "components/common/Typography";
import { setBookmarkedInncodes } from "components/features/MyPlans/myplans.slice";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getUIFormatDate } from "utils/DateHelper";
import { fetchMyListDetails, fetchPlanDetails } from "../home/sme.slice";
import PlanItem from "./planItem";

const InncodeStats = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(0);
  const { isMobileScreen } = useContext(ThemeContext);
  const { innCodeStats, myListDetails, users, innCodeStatsTotal } = useAppSelector((state) => state.sme);
  const adminInnCodes: any = useAppSelector((state) => state.myplans.MyPlans.adminInncodes);
  const details: any = myListDetails?.mappings.filter((m: any) => m.id.toString() === params?.id)[0];
  // @ts-ignore
  const username = users.filter((u: any) => u.hltId === details?.hltId)[0]?.displayName;

  useEffect(() => {
    dispatch(fetchMyListDetails({ id: params?.listId, view: "inncodes" }));
  }, []);

  useEffect(() => {
    if (details?.innCode && page < 1) {
      dispatch(fetchPlanDetails({ id: params?.id, innCodeGroupId: params?.listId, innCode: details?.innCode }));
    }
  }, [details]);

  const fetchMore = () => {
    dispatch(
      fetchPlanDetails({ id: params?.id, innCodeGroupId: params?.listId, innCode: details?.innCode, page: page + 1 })
    );
    setPage((pageNo) => pageNo + 1);
  };

  const handleNavigateToAllPlans = () => {
    dispatch(setBookmarkedInncodes(adminInnCodes));
    navigate("/myplans");
  };

  return (
    <>
      <Stack
        spacing={2}
        direction={isMobileScreen ? "column" : "row"}
        alignItems="center"
        sx={{
          paddingY: "32px",
          borderBottom: isMobileScreen ? "none" : `1px solid ${tokens.Border.General.Tertiary}`
        }}
      >
        <Box sx={{ flex: 3 }}>
          <Typography
            variant="h4"
            showBold
            color={tokens.Text.General.PrimaryHeadline}
            sx={{
              flex: 1,
              textAlign: isMobileScreen ? "center" : "left"
            }}
          >
            {details?.innCode}
          </Typography>
          <Typography
            variant="body1"
            color={tokens.Text.General.PrimaryHeadline}
            sx={{ marginY: "12px", textAlign: isMobileScreen ? "center" : "left" }}
          >
            {username}
          </Typography>
          <Stack
            direction={isMobileScreen ? "column" : "row"}
            alignItems="center"
            sx={{ color: tokens.Text.General.Secondary }}
          >
            <Stack direction="row" alignItems="center" sx={{ marginBottom: isMobileScreen ? "10px" : 0 }}>
              <AssignPlanIcon />
              <Typography
                variant="body2"
                sx={{
                  borderRight: isMobileScreen ? "none" : `1px solid ${tokens.Border.General.Secondary}`,
                  paddingRight: isMobileScreen ? "0" : "12px",
                  marginRight: isMobileScreen ? "0" : "12px",
                  marginLeft: "6px"
                }}
              >
                Plan Assignment: <b>{`${details?.plansCount} Plan(s)`}</b>
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center">
              <CalendarTodayIcon sx={{ fontSize: "16px" }} />
              <Typography
                variant="body2"
                sx={{
                  marginLeft: "6px"
                }}
              >
                Last Assignment: <b>{getUIFormatDate(details?.lastAssignmentDate)}</b>
              </Typography>
            </Stack>
          </Stack>
        </Box>

        <Stack
          direction={isMobileScreen ? "column" : "row"}
          alignItems="center"
          sx={{ backgroundColor: tokens.Background.General.Tertiary, padding: "16px", borderRadius: "8px", flex: 2 }}
        >
          <Box
            sx={{ flex: 1, marginRight: isMobileScreen ? "0" : "80px", textAlign: isMobileScreen ? "center" : "left" }}
          >
            <Typography variant="body2" showBold color={tokens.Text.General.PrimaryHeadline}>
              All Inncode plans
            </Typography>
            <Typography
              variant="body2"
              color={tokens.Text.General.PrimaryHeadline}
              sx={{ marginY: isMobileScreen ? "16px" : "0" }}
            >
              Go to all plans If want to see all the plans assigned to this Inncode
            </Typography>
          </Box>
          <Button label="All Plans" onClick={handleNavigateToAllPlans} />
        </Stack>
      </Stack>
      {!isMobileScreen && (
        <Stack spacing={2} direction="row" alignItems="center" sx={{ padding: "16px 24px" }}>
          <Typography variant="label" color={tokens.Text.General.Secondary} sx={{ flex: 1 }}>
            Plan Name
          </Typography>
          <Stack direction="row" alignItems="center" sx={{ flex: 1 }}>
            <Typography variant="label" color={tokens.Text.General.Secondary} sx={{ flex: 1 }}>
              Functional Area
            </Typography>
            <Typography variant="label" color={tokens.Text.General.Secondary} sx={{ flex: 1 }}>
              Due Date
            </Typography>
            <Typography variant="label" color={tokens.Text.General.Secondary} sx={{ flex: 1 }}>
              Status
            </Typography>
            <Box sx={{ flex: 1 }} />
          </Stack>
        </Stack>
      )}

      <Scroller dataLength={innCodeStats?.length} loadMore={fetchMore} totalList={innCodeStatsTotal} label="">
        {innCodeStats?.map((plan: any) => (
          <PlanItem key={plan.id} data={plan} />
        ))}
      </Scroller>
    </>
  );
};

export default InncodeStats;
